<template>
    <div class="industry-teaser grid grid__base">
        <div class="grid--container">
            <div class="industry-teaser--row grid--row">
                <div class="industry-teaser--col grid--col">
                    <div class="industry-teaser--swiper-container swiper-container" ref="slider">
                        <div class="industry-teaser--pagination-wrapper" v-if="swiper">
                            <button class="industry-teaser--pagination-item"
                                    v-for="(item, idx) in items"
                                    :class="getActiveFacet(idx, 'pagination-item')"
                                    :key="idx"
                                    @click="goToSlide(idx)"
                            >
                                {{ item.industry }}
                            </button>
                        </div>
                        <div class="industry-teaser--content-wrapper swiper-wrapper">
                            <div class="industry-teaser--slide swiper-slide"
                                    v-for="(item, idx) in items"
                                    :class="getActiveFacet(idx, 'slide')"
                                    :key="idx"
                                    @click="onSlideClicked($event, idx)"
                            >
                                <morph-component
                                        class="link link__flex-element industry-teaser--slide-content"
                                        default-component="dyn-content-teaser"
                                        :components="{ '<=sm': 'dyn-content-card'}"
                                        :slots="['title', 'content', 'image', 'links']"
                                        :facets="['industry-teaser', 'circle-header', 'same-height']"
                                >
                                    <h3 class="u-reset" slot="morph-title">{{ item.title }}</h3>
                                    <p class="u-reset industry-teaser--description" slot="morph-content">
                                        {{ item.description }}
                                    </p>

                                    <a class="u-reset link link__no-underline link__icon"
                                            slot="morph-links"
                                            :href="item.link.path"
                                    >
                                        <span class="link--label">{{ item.link.label }}</span>
                                        <base-icon symbol="arrow-right" size="small" class="link--icon"/>
                                    </a>

                                    <picture-element
                                            v-if="isOnMobile"
                                            slot="morph-image"
                                            v-bind="item.video_fallback_dict"/>

                                    <is-visible class="industry-teaser--video-wrapper" v-else slot="morph-image">
                                        <dyn-lazy-video
                                                :webm-src="item.visual_video_webm.urls.default[videoResolutionPositionIndex]"
                                                :mp4-src="item.visual_video_mp4.urls.default[videoResolutionPositionIndex]"
                                                :poster="item.visual_video_poster.urls.default[0]"
                                                :fallback="item.video_fallback_dict.urls.default[0]"
                                                :loop="true"
                                                :facets="['industry-teaser']"/>
                                    </is-visible>
                                </morph-component>
                            </div>
                        </div>
                        <div class="industry-teaser--mobile-pagination-wrapper"/>
                    </div>
                </div>
            </div>

            <div class="industry-teaser--row grid--row">
                <div class="industry-teaser--cta-col grid--col">
                    <slot name="cta"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Swiper from 'swiper';
    import bemMixin from 'framework/mixins/bem';
    import ContentTeaser from 'framework/global-components/dyn/content-teaser/content-teaser';
    import MorphComponent from 'framework/global-components/dyn/morph-component/morph-component';
    import { mq } from 'util/dom/mq';
    import PictureElement from 'framework/global-components/dyn/picture-element/picture-element';
    import IsVisible from 'framework/components/is-visible/is-visible';

    export default {
        components: { IsVisible, PictureElement, MorphComponent, ContentTeaser },
        mixins: [bemMixin('industry-teaser')],
        props: {
            /** @type {IIndustryTeaseItem[]} */
            items: {
                type: Array,
                required: true,
            },
        },

        data() {
            return {
                swiper: null,
            };
        },

        computed: {
            ...mapState('viewport', ['mq']),

            videoResolutionPositionIndex() {
                return this.mq.resolution && this.mq.resolution === 'res2x' ? 1 : 0;
            },

            isOnMobile() {
                return mq('<=sm');
            },

            currentActiveSlide() {
                if (!this.swiper) {
                    return null;
                }

                return this.swiper.activeIndex;
            },
        },

        methods: {
            onSlideClicked(event, slideIdx) {
                if (!this.isSlideActive(slideIdx)) {
                    event.preventDefault();
                    this.goToSlide(slideIdx);
                    return;
                }

                window.location = this.items[slideIdx].link.path;
            },

            goToSlide(slideidx) {
                this.swiper.slideTo(slideidx);
            },

            isSlideActive(slideIdx) {
                return this.currentActiveSlide === slideIdx;
            },

            getActiveFacet(idx, item) {
                return this.bemAdd(this.isSlideActive(idx) ? 'active' : 'inactive', item);
            },
        },

        beforeDestroy() {
            if (this.swiper) {
                this.swiper.destroy();
            }
        },

        mounted() {
            this.swiper = new Swiper(this.$refs.slider, {
                speed: 200,
                spaceBetween: 26,
                slidesPerView: 'auto',
                centeredSlides: true,
                threshold: 20,
                pagination: {
                    bulletClass: 'industry-teaser--mobile-pagination-bullet',
                    bulletActiveClass: 'industry-teaser--mobile-pagination-bullet__active',
                    el: '.industry-teaser--mobile-pagination-wrapper',
                },
            });

            setTimeout(() => {
                this.swiper.update();
            }, 100);
        },
    };
</script>
